module.exports = __webpack_public_path__ + "media/images/sm_icon06-f9cfe864f2c1ff41bccf9d4a2b5761f8.png";